import * as actions from "./actionTypes";
import { Attachment as CommentAttachment } from "../../screens/Comments/types";
import { Attachment as TicketAttachment } from "../../types";

export const fetch = (attachment: CommentAttachment | TicketAttachment) => {
  return { type: actions.FETCH, attachment };
};
